// extracted by mini-css-extract-plugin
module.exports = {"component":"progress-details_component_1n1f9"};